/**
 * @ngdoc directive
 * @name img
 *
 * @description
 * Overrides default img directive to add following features :
 * - absolute path resolving
 * - data preloading
 */
module.directive('img', function (image, $timeout) {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            if(element.attr("aqua-src")){
                var loader;
                element.addClass('aqua-img');
                element.addClass('empty');

                attrs.$observe('aquaSrc', function (value) {
                    if(!element.hasClass("loaded")) {
                        element.addClass('empty');
                        if (value) {
                            if (loader) {
                                loader.reject();
                            }
                            loader = image.whenVisible(element);
                            loader.promise.then(function () {
                                return image.load(element, value).then(function (url) {
                                    attrs.$set('src', url);
                                    $timeout(function() {
                                        element.removeClass('empty');
                                        element.addClass('loaded');
                                    }, 100);
                                });
                            }).catch(function (e) {});
                        }
                    }
                });
            }
        }
    }
});

module.directive('img', function (image, $timeout) {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            if (!element.attr('aqua-src') && !element.attr('aqua-background-img')) {
                element.on("load",function(){
                    element.addClass("loaded")
                })
            }
        }
    }
});

module.directive('aquaBackgroundImg', function (image, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            if(element.attr("aqua-background-img")){
                element.addClass('aqua-img');
                element.addClass('empty');

                attrs.$observe('aquaBackgroundImg', function (value) {
                    if(!element.hasClass("loaded")) {
                        element.addClass('empty');
                        if (value) {
                            image.whenVisible(element).promise.then(function () {
                                return image.load(element, value).then(function (url) {
                                    element.css({backgroundImage: 'url(' + url + ')'});
                                    $timeout(function() {
                                        element.removeClass('empty');
                                        element.addClass("loaded");
                                    }, 100);
                                })
                            }).catch(function (e) {});
                        }
                    }
                });
            }
        }
    }
});

/**
 * @ngdoc directive
 * @name aeroBackgroundImg
 *
 * @description
 * Same as image directive but for backgrounds.
 */
module.directive('aquaBackgroundImg', function (image, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.addClass('aqua-img');
            element.addClass('empty');

            attrs.$observe('aquaBackgroundImg', function (value) {
                if(!element.hasClass("loaded")) {
                    element.addClass('empty');
                    if (value) {
                        image.whenVisible(element).promise.then(function () {
                            return image.load(element, value).then(function (url) {
                                element.css({backgroundImage: 'url(' + url + ')'});
                                $timeout(function() {
                                    element.removeClass('empty');
                                    element.addClass("loaded");
                                }, 100);
                            })
                        }).catch(function (e) {});
                    }
                }
            });
        }
    }
});
